// Source: app/scripts/controllers/upcoming-auctions.js
/**
 * Created by ristes on 20.4.15.
 */


Auction.controller('UpcomingAuctionsController', [
  '$scope',
  '$filter',
  '$routeParams',
  '$timeout',
  'toaster',
  'crudService',
  'Stomp',
  function ($scope, $filter, $routeParams, $timeout, toaster, crudService, Stomp) {

    Stomp("/topic/auction/", "all", function () {
      $timeout(load, 1000);
    }, $scope);

    var service = crudService('auctions', {
        toolbarAuctions: {
          method: 'GET',
          url: '/data/rest/auctions/promoted_auctions'
        }
      }
    );


    function load() {
      service.toolbarAuctions(function (data) {
        var i;
        $scope.upcoming = [];
        $scope.upcomingMap = {};
        $scope.running = [];
        $scope.runningMap = {};
        $scope.canceled = [];
        $scope.canceledMap = {};
        for (i = 0; i < Math.min(data.upcoming.length, 3); i++) {
          $scope.upcoming.push(data.upcoming[i]);
          $scope.upcomingMap[data.upcoming[i].id] = i;
        }
        for (i = 0; i < Math.min(data.running.length, 3); i++) {
          $scope.running.push(data.running[i]);
          $scope.runningMap[data.running[i].id] = i;
        }
        for (i = 0; i < Math.min(data.canceled.length, 3); i++) {
          $scope.canceled.push(data.canceled[i]);
          $scope.canceledMap[data.canceled[i].id] = i;
        }
      });
    }

    load();
  }
]);
